import * as React from 'react';
import styled from 'styled-components';

import StringParser from 'Jsx/Shared/StringParser';

const WrapperText = styled.div`
  max-height: 252px;
  min-height: 252px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    max-height: 192px;
    min-height: 192px;
  }
`;

const ContentText = styled.div`
  max-height: 222px;
  min-height: 222px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    max-height: 162px;
    min-height: 162px;
  }
`;

type TransciptProp = {
  textTranscript: string;
};

const Transcript: React.FC<TransciptProp> = ({ textTranscript }) => {
  return (
    <div className="w-full ">
      <h4 className="font-h4 text-base-main mb-24">Transcripts</h4>
      <WrapperText className="border border-solid border-gray-main p-16 w-full">
        <ContentText className="w-full overflow-auto">
          <StringParser string={textTranscript} style>
            {({ string: text }) => (
              <div className="font-body4 text-base-main">{text}</div>
            )}
          </StringParser>
        </ContentText>
      </WrapperText>
    </div>
  );
};

export default Transcript;
